<div class="related-card">
  <div class="related-card__photo">
    <div class="related-card__img">
      <picture class="cover-picture" *ngIf="currentSize && currentSize.buttonImage && currentSize.buttonImage['src']; else photoPlaceholder">
        <source srcset="{{ currentSize.buttonImage['254x196x100.webp'] }}">
        <img ngSrc="{{ currentSize.buttonImage['src'] }}" loading="auto" [alt]="product.name" width="96" height="96" appPictureFallback>
      </picture>
    </div>
  </div>
  <div class="related-card__title h5">{{ product.name | cropText:13 }}</div>
  <ng-container *ngIf="isBasketMode$ | async">
    <div class="related-card__ctrl" *ngIf="currentSize && defaultPrice$ | async as defaultPrice">
      <button
        *ngIf="(basketItem$ | async) === null"
        class="button button--th-main _xs _rounded"
        type="button"
        (click)="onAddItem(product.balance && product.balance < 0 ? null : product.slug)"
      >
        <app-product-price [price]="defaultPrice"></app-product-price>
      </button>

      <app-counter
        *ngIf="basketItem$ | async as basketItem"
        [min]="1"
        [max]="product.balance ?? 10000"
        [isDisabled]="product.balance === 0"
        [formControl]="counterControl"
        (changeValue)="onChangeCount(basketItem.itemKey, $event)"
      ></app-counter>
    </div>
  </ng-container>

  <a class="related-card__link" (click)="onOpenCard(product.balance && product.balance < 0 ? null : product.slug)"></a>
</div>

<ng-template #photoPlaceholder>
  <i class="icomoon icomoon--dish-placeholder"></i>
</ng-template>
